import { useTranslation } from "react-i18next";

export const useUserDetails = (user) => {
  const { t } = useTranslation();

  const getVerboseDetails = (detailed = false) => {
    const role = user.class.toLowerCase();
    if (role === "owner") {
      return t("Owner");
    } else if (role === "member") {
      if (!user.custom_permissions || user.custom_permissions.length === 0) {
        return t("Member");
      } else {
        if (!detailed) {
          return `${t("Member")}+`;
        } else {
          let result = [t("Member")];
          if (user.custom_permissions?.includes("can_manage_projects")) {
            result.push(t("Managing projects"));
          }
          if (user.custom_permissions?.includes("can_manage_finances")) {
            result.push(t("Managing finances"));
          }
          return result.join(", ");
        }
      }
    } else if (role === "subcontractor") {
      return t("Subcontractor");
    } else if (role === "client" && user.custom_permissions?.includes("can_manage_tasks")) {
      return t("Client+");
    } else {
      return t("Client");
    }
  };
  return {
    getVerboseDetails,
  };
};
